module.exports = __webpack_public_path__ + "img/what-is-oah-enterprise-thumbnail-arrow-tc.cc6e3bb7.jpg";